import { render, staticRenderFns } from "./adminPay.vue?vue&type=template&id=8dfee2c6&scoped=true"
import script from "./adminPay.js?vue&type=script&lang=js&external"
export * from "./adminPay.js?vue&type=script&lang=js&external"
import style0 from "./adminPay.less?vue&type=style&index=0&id=8dfee2c6&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfee2c6",
  null
  
)

export default component.exports